export default __webpack_public_path__ + "static/media/mixkit-electric-fence-buzzing-2967.99424606.wav";